<app-form-question-container [name]="name" [questionId]="questionId" [tooltip]="tooltip">
  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field fxFlex="20" appearance="outline" class="text-field">
      <input matInput type="text" [formControl]="formControl" (change)="onTextChange()" (keyup.enter)="onTextChange()" />
      @if (formControl.invalid && formControl.touched) {
        <mat-error>
          {{ 'InvalidField' | translate }}
        </mat-error>
      }
    </mat-form-field>
    @for (item of checkboxList; track item) {
      <mat-checkbox
        (change)="onOptionChange()"
        [value]="item.value"
        [disabled]="isDisabled || (selectedOptionsGroupId && selectedOptionsGroupId !== item.value.GroupId)"
        [(ngModel)]="item.selected"
        >
        {{ item.value.Name }}
      </mat-checkbox>
    }
  </div>
</app-form-question-container>
